// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sa-layout {
  display: grid;
  grid-template-columns: 280px 1fr;
  gap: 24px;
  align-items: start;
}

.sa-categories {
  background: #fff;
  border-radius: 10px;
  box-shadow: 0 2px 10px rgba(0,0,0,0.08);
  padding: 16px;
}

.sa-categories-title {
  font-size: 13px;
  font-weight: 700;
  text-transform: uppercase;
  color: #888;
  letter-spacing: 0.5px;
  margin-bottom: 12px;
}

.sa-category-list {
  list-style: none;
  margin: 0 0 14px;
  padding: 0;
}

.sa-category-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding: 10px 8px;
  border-radius: 6px;
  cursor: default;
}

.sa-category-item.active {
  background: #e8f0fe;
}

.sa-category-name {
  flex: 1 1;
  cursor: pointer;
  font-size: 14px;
  color: #222;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.sa-category-count {
  color: #999;
  font-size: 12px;
}

.sa-category-actions {
  display: flex;
  gap: 4px;
  flex-shrink: 0;
}

.sa-icon-btn {
  background: none;
  border: none;
  cursor: pointer;
  color: #888;
  font-size: 13px;
  padding: 4px 6px;
  border-radius: 4px;
}
.sa-icon-btn:hover { background: #f0f4f8; color: #333; }
.sa-icon-btn-danger:hover { background: #fde8e8; color: #c81e1e; }
.sa-icon-btn:disabled { opacity: 0.6; cursor: not-allowed; }

.sa-rename-input {
  flex: 1 1;
  font-size: 14px;
  padding: 4px 6px;
  border: 1px solid #d0d7de;
  border-radius: 4px;
}

.sa-new-category {
  display: flex;
  gap: 6px;
  border-top: 1px solid #eee;
  padding-top: 12px;
}

.sa-new-category input {
  flex: 1 1;
  padding: 9px 10px;
  border: 1px solid #d0d7de;
  border-radius: 6px;
  font-size: 13px;
}

.sa-new-category button {
  background: #222e3c;
  color: #fff;
  border: none;
  padding: 9px 14px;
  border-radius: 6px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  white-space: nowrap;
}
.sa-new-category button:disabled { opacity: 0.6; cursor: not-allowed; }

.sa-stickers {
  background: #fff;
  border-radius: 10px;
  box-shadow: 0 2px 10px rgba(0,0,0,0.08);
  padding: 20px;
  min-height: 300px;
}

.sa-stickers-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;
}

.sa-stickers-header h3 {
  font-size: 18px;
  color: #222;
}

.sa-upload-btn {
  background: #222e3c;
  color: #fff;
  border: none;
  padding: 10px 18px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.2s;
}
.sa-upload-btn:hover { background: #1a2230; }
.sa-upload-btn-disabled { opacity: 0.6; cursor: not-allowed; }

.sa-sticker-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(120px, 1fr));
  gap: 16px;
}

.sa-sticker-card {
  background: #f8f9fb;
  border-radius: 8px;
  padding: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
}

.sa-sticker-thumb {
  width: 100%;
  height: 90px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.sa-sticker-thumb img {
  max-width: 100%;
  max-height: 100%;
}

.sa-sticker-delete {
  width: 100%;
  padding: 6px 0;
  border: none;
  border-radius: 6px;
  background: #fde8e8;
  color: #c81e1e;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
}
.sa-sticker-delete:hover { background: #fbd5d5; }
.sa-sticker-delete:disabled { opacity: 0.6; cursor: not-allowed; }

@media (max-width: 800px) {
  .sa-layout {
    grid-template-columns: 1fr;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/StickersAdmin.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,gCAAgC;EAChC,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,uCAAuC;EACvC,aAAa;AACf;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,WAAW;EACX,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,eAAe;EACf,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;AACA,qBAAqB,mBAAmB,EAAE,WAAW,EAAE;AACvD,4BAA4B,mBAAmB,EAAE,cAAc,EAAE;AACjE,wBAAwB,YAAY,EAAE,mBAAmB,EAAE;;AAE3D;EACE,SAAO;EACP,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,0BAA0B;EAC1B,iBAAiB;AACnB;;AAEA;EACE,SAAO;EACP,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,mBAAmB;AACrB;AACA,mCAAmC,YAAY,EAAE,mBAAmB,EAAE;;AAEtE;EACE,gBAAgB;EAChB,mBAAmB;EACnB,uCAAuC;EACvC,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,2BAA2B;AAC7B;AACA,uBAAuB,mBAAmB,EAAE;AAC5C,0BAA0B,YAAY,EAAE,mBAAmB,EAAE;;AAE7D;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;AACA,2BAA2B,mBAAmB,EAAE;AAChD,8BAA8B,YAAY,EAAE,mBAAmB,EAAE;;AAEjE;EACE;IACE,0BAA0B;EAC5B;AACF","sourcesContent":[".sa-layout {\n  display: grid;\n  grid-template-columns: 280px 1fr;\n  gap: 24px;\n  align-items: start;\n}\n\n.sa-categories {\n  background: #fff;\n  border-radius: 10px;\n  box-shadow: 0 2px 10px rgba(0,0,0,0.08);\n  padding: 16px;\n}\n\n.sa-categories-title {\n  font-size: 13px;\n  font-weight: 700;\n  text-transform: uppercase;\n  color: #888;\n  letter-spacing: 0.5px;\n  margin-bottom: 12px;\n}\n\n.sa-category-list {\n  list-style: none;\n  margin: 0 0 14px;\n  padding: 0;\n}\n\n.sa-category-item {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  padding: 10px 8px;\n  border-radius: 6px;\n  cursor: default;\n}\n\n.sa-category-item.active {\n  background: #e8f0fe;\n}\n\n.sa-category-name {\n  flex: 1;\n  cursor: pointer;\n  font-size: 14px;\n  color: #222;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.sa-category-count {\n  color: #999;\n  font-size: 12px;\n}\n\n.sa-category-actions {\n  display: flex;\n  gap: 4px;\n  flex-shrink: 0;\n}\n\n.sa-icon-btn {\n  background: none;\n  border: none;\n  cursor: pointer;\n  color: #888;\n  font-size: 13px;\n  padding: 4px 6px;\n  border-radius: 4px;\n}\n.sa-icon-btn:hover { background: #f0f4f8; color: #333; }\n.sa-icon-btn-danger:hover { background: #fde8e8; color: #c81e1e; }\n.sa-icon-btn:disabled { opacity: 0.6; cursor: not-allowed; }\n\n.sa-rename-input {\n  flex: 1;\n  font-size: 14px;\n  padding: 4px 6px;\n  border: 1px solid #d0d7de;\n  border-radius: 4px;\n}\n\n.sa-new-category {\n  display: flex;\n  gap: 6px;\n  border-top: 1px solid #eee;\n  padding-top: 12px;\n}\n\n.sa-new-category input {\n  flex: 1;\n  padding: 9px 10px;\n  border: 1px solid #d0d7de;\n  border-radius: 6px;\n  font-size: 13px;\n}\n\n.sa-new-category button {\n  background: #222e3c;\n  color: #fff;\n  border: none;\n  padding: 9px 14px;\n  border-radius: 6px;\n  font-size: 13px;\n  font-weight: 600;\n  cursor: pointer;\n  white-space: nowrap;\n}\n.sa-new-category button:disabled { opacity: 0.6; cursor: not-allowed; }\n\n.sa-stickers {\n  background: #fff;\n  border-radius: 10px;\n  box-shadow: 0 2px 10px rgba(0,0,0,0.08);\n  padding: 20px;\n  min-height: 300px;\n}\n\n.sa-stickers-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 20px;\n}\n\n.sa-stickers-header h3 {\n  font-size: 18px;\n  color: #222;\n}\n\n.sa-upload-btn {\n  background: #222e3c;\n  color: #fff;\n  border: none;\n  padding: 10px 18px;\n  border-radius: 8px;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: background 0.2s;\n}\n.sa-upload-btn:hover { background: #1a2230; }\n.sa-upload-btn-disabled { opacity: 0.6; cursor: not-allowed; }\n\n.sa-sticker-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(120px, 1fr));\n  gap: 16px;\n}\n\n.sa-sticker-card {\n  background: #f8f9fb;\n  border-radius: 8px;\n  padding: 10px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 8px;\n}\n\n.sa-sticker-thumb {\n  width: 100%;\n  height: 90px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.sa-sticker-thumb img {\n  max-width: 100%;\n  max-height: 100%;\n}\n\n.sa-sticker-delete {\n  width: 100%;\n  padding: 6px 0;\n  border: none;\n  border-radius: 6px;\n  background: #fde8e8;\n  color: #c81e1e;\n  font-size: 12px;\n  font-weight: 600;\n  cursor: pointer;\n}\n.sa-sticker-delete:hover { background: #fbd5d5; }\n.sa-sticker-delete:disabled { opacity: 0.6; cursor: not-allowed; }\n\n@media (max-width: 800px) {\n  .sa-layout {\n    grid-template-columns: 1fr;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
